var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('notifications',{attrs:{"group":"alert","position":"bottom right","duration":1000}}),_c('base-layout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }